export default class AccountUtil {

    static checkForRavensWithoutSubscriptions(ravens, accountDetails) {
        var ravensWithoutSubscriptions = [];
        ravens.forEach((raven, ravenIndex) => { //check if raven has an active subscription associated with it.
            if (raven.accessLevel === "OWNER") { //only check if this raven is owned by this user
                var sub = AccountUtil.getRavenActiveSubscription(raven.ravenUuid);
                if (!sub) {
                    ravensWithoutSubscriptions.push(ravenIndex);
                }
            }
        });

        return ravensWithoutSubscriptions;
    }

    static getRavenActiveSubscription(ravenUuid, subscriptions) {

        return subscriptions.find(sub => {
            if (sub.raven && sub.state !== 'pending') return sub.raven.ravenUuid === ravenUuid
        });
    }
}